import { render, staticRenderFns } from "./PalletSplit.vue?vue&type=template&id=790f2422&scoped=true"
import script from "./PalletSplit.vue?vue&type=script&lang=js"
export * from "./PalletSplit.vue?vue&type=script&lang=js"
import style0 from "./PalletSplit.vue?vue&type=style&index=0&id=790f2422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f2422",
  null
  
)

export default component.exports